<template>
  <div
    class="themic"
    style="height:calc(100vh - 360px); margin-left:8px; width:380px"
  >
    <div class="--header">
      <Select
        :items="[{ val: 'asd', text: 'Chart per Balai' }]"
        :value.sync="chartSp"
        width="100%"
      />
    </div>
    <BarChart
      :chart-data="datacollection"
      :options="chartOptions"
      class="yearly-chart --body"
      style="padding-top:10px"
    ></BarChart>
  </div>
</template>
<script>
import BarChart from '../../components/Charts/Bar'
export default {
  components: {
    BarChart,
  },
  data: () => ({
    chartSp: 'asd',
    progress: {},
    datacollection: {},
    chartOptions: {
      title: {
        display: false,
        text: 'CHART PER BALAI',
        fontSize: '16',
      },
      legend: {
        labels: {
          usePointStyle: true,
          pointRadius: 2,
        },
        position: 'bottom',
      },
      scales: {
        yAxes: [
          {
            stacked: true,
          },
        ],
        xAxes: [
          {
            stacked: true,
          },
        ],
      },
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  props: {
    sumber: [Number, String],
  },
  watch: {
    sumber() {
      this.populateProgress()
      this.populateChart()
    },
  },
  created() {
    this.populateProgress()
    this.populateChart()
  },
  methods: {
    async populateProgress() {
      //   let { data } = await this.$api.call('PRM.SelChartProgress', {
      //     TipeData: this.tipeData,
      //   })
      //   this.progress = data[0]
      //   this.progress.TotalIntervensi =
      //     0 +
      //     data[0].APBN +
      //     data[0].APBD1 +
      //     data[0].APBD2 +
      //     data[0].CSR +
      //     data[0].Lain +
      //     data[0].Validasi +
      //     data[0].DiluarPrioritas
      //   this.progress.SisaPBDT = data[0].TotalData - this.progress.TotalIntervensi
    },
    async populateChart() {
      this.chartOptions.title.text = 'Penerimaan per Balai'

      let [{ data }, { data: target }] = await Promise.all([
        this.$api.call('AST_SelChartPerBalai', {}),
        this.$api.call('AST_SelTarget', {}),
      ])

      let labelObj = {},
        kategoriObj = {},
        nilaiObj = {}
      data.forEach(d => {
        labelObj[d.Label] = true
        if (d.Kategori) {
          kategoriObj[d.Kategori] = true

          let key = d.Label + '-' + d.Kategori
          if (!nilaiObj[key]) nilaiObj[key] = 0
          nilaiObj[key] += d.Nilai
        }
      })
      let colors = [
        '#29066b',
        '#7d3ac1',
        '#af4bce',
        '#db4cb2',
        '#eb548c',
        '#ea7369',
        '#f0a58f',
        '#fceae6',
      ]
      let ds = []
      let total = {}
      let idx = 0
      Object.keys(kategoriObj).forEach(k => {
        let dx = {
          label: k,
          type: 'bar',
          data: [],
          baseColor: colors[idx],
          backgroundColor: colors[idx],
          pointStyle: 'rectRot',
          pointRadius: 3,
        }

        // total[label] = 0
        Object.keys(labelObj).forEach(label => {
          let key = label + '-' + k
          dx.data.push(nilaiObj[key] || 0)
          // lx.data.push((nilaiObj[key] || 0) + 100000)
          total[label] += nilaiObj[key]
        })
        // dx.label = `${label} (${(total[label] || 0).toLocaleString()})`
        ds.push(dx)
        idx++
      })
      let lx = {
        label: 'Target',
        type: 'line',
        data: target.map(d => d.Target),
        baseColor: colors[idx],
        pointStyle: 'rectRot',
        pointRadius: 3,
      }

      ds.push(lx)
      this.datacollection = {
        labels: Object.keys(labelObj),
        datasets: ds,
      }
    },
    randomScalingFactor() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
  },
}
</script>
<style lang="scss">
.realisasi-chart {
  canvas {
    height: 300px;
  }
}
</style>
